import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { PracticeArea } from '../../../../backend/src/user/practice-area';
import { APIBaseChronos } from '../hosts';
import { parseErrorMessage } from '../parse-error';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface Props {
  userId: string;
  roleId?: string;
  practiceArea?: PracticeArea;
}

export const useUpdateUser = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateUser = async (data: Props) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { roleId: data.roleId, practiceArea: data.practiceArea },
    });

    const response = await fetch(`${APIBaseChronos}/api/user/${data.userId}`, fetchConfig);

    if (!response.ok) {
      throw new Error((await parseErrorMessage(response)) || 'Failed to update user');
    }
  };

  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      toast.success('User updated successfully');
      queryClient.invalidateQueries([QueryEntity.Users]);
      queryClient.invalidateQueries([QueryEntity.User]);
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
  });
};
